import { Middleware } from 'redux';
import { EndPoints } from 'src/config';
import { checkApiError } from 'src/handlers';
import { appHeaders } from 'src/helpers/auth';
import { InStoreAgencyInfo, START_LOADING_IN_STORE_AGENCY_INFO } from '../../InStore.types';
import {
  setInStoreAgenciesList,
  setInStoreAgencyError,
  setInStoreAgencyInfo,
  setInStoreAgencyLoader,
  setInStoreIsFromAgencyMarketing,
} from '../InStoreSlice';

type InStoreAgencyInfosResponseSuccess = {
  currentAgency: InStoreAgencyInfo;
  agencies: InStoreAgencyInfo[];
  marketingAgencyId?: string;
};

export const InStoreLoadAgencyMiddleware: Middleware = (api) => (next) => async (action) => {
  const { type } = action;

  if (type !== START_LOADING_IN_STORE_AGENCY_INFO) {
    next(action);
    return;
  }

  next(setInStoreAgencyLoader({ isLoading: true }));

  const { slug } = action;

  try {
    const response = await fetch(EndPoints.getAgencyInfoBySlug, {
      headers: appHeaders(),
      method: 'POST',
      body: JSON.stringify({
        slug,
      }),
    });

    const json = await response.json();
    checkApiError(json);

    const successResponse = json as InStoreAgencyInfosResponseSuccess;
    next(setInStoreAgencyInfo({ info: successResponse.currentAgency }));
    next(setInStoreAgenciesList({ agencies: successResponse.agencies }));
    next(setInStoreIsFromAgencyMarketing(successResponse.marketingAgencyId));
  } catch (e) {
    next(setInStoreAgencyError({ error: e as Error }));
  } finally {
    next(setInStoreAgencyLoader({ isLoading: false }));
  }
};
